import { DoricPlugin } from "../DoricPlugin";
export class StoragePlugin extends DoricPlugin {
    setItem(args) {
        localStorage.setItem(`${args.zone}_${args.key}`, args.value);
        return Promise.resolve();
    }
    getItem(args) {
        return Promise.resolve(localStorage.getItem(`${args.zone}_${args.key}`));
    }
    remove(args) {
        localStorage.removeItem(`${args.zone}_${args.key}`);
        return Promise.resolve();
    }
    clear(args) {
        let removingKeys = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(`${args.zone}_`)) {
                removingKeys.push(key);
            }
        }
        removingKeys.forEach(e => {
            localStorage.removeItem(e);
        });
        return Promise.resolve();
    }
}
//# sourceMappingURL=StoragePlugin.js.map